module.exports = __webpack_public_path__ + "img/顽趣惊喜_礼物.c37d4c24.png";